export const button = {
  padding: '10px 20px',
  default: {
    fontSize: 1.8,
    lineHeight: 1.8,
    weight: '500',
    padding: '15px 20px'
  },
  large: {
    fontSize: 2.2,
    lineHeight: 2.2,
    weight: '500',
    padding: '15px 20px'
  },
  small: {
    fontSize: 1.6,
    lineHeight: 1.6,
    weight: '500',
    padding: '10px 20px'
  }
};
